// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ujpZ","newExpiryDate":"styles_newExpiryDate__1I9Ll","footer":"styles_footer__PTTgS"};